import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { switchMap, map, catchError, take, finalize } from 'rxjs/operators';
import * as MachineServiceListActions from './machine-service.actions';
import { TMachineServiceInfoActionType } from './machine-service.models';
import { MachineServiceListFacade } from './machine-service.facade';
import { AppNotificationUtilClass, MachineMaintenanceDataService } from '@monorepo/services';

@Injectable({ providedIn: 'root' })
export class MachineServiceListEffects {
  constructor(
    private actions$: Actions,
    private mmDataService: MachineMaintenanceDataService,
    private machineServiceListFacade: MachineServiceListFacade,
    private APIHelper: AppNotificationUtilClass,
  ) {}

  getMachineServiceList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TMachineServiceInfoActionType.GetMachineServiceList),
      switchMap((action: MachineServiceListActions.GetMachineServiceList) =>
        this.machineServiceListFacade.getPagination().pipe(
          take(1),
          map((pagination) => {
            return [action, pagination] as const;
          }),
        ),
      ),
      switchMap((args) =>
        from(this.APIHelper.presentLoading()).pipe(
          take(1),
          map((loaderEl) => {
            return [loaderEl, ...args] as const;
          }),
        ),
      ),
      switchMap(([loaderEl, action, pagination]) =>
        this.mmDataService
          .fetchMachineServiceListData({
            page: pagination.pageNo,
            itemsPerPage: pagination.pageSize,
            selectedFilters: action.selectedFilters,
          })
          .pipe(
            finalize(() => {
              this.APIHelper.dismissLoadingV2(loaderEl);
            }),
            map((res) => new MachineServiceListActions.GetMachineServiceListSuccess(res, action.fetchReason)),
            catchError(() => {
              return of(new MachineServiceListActions.GetMachineServiceListFailure());
            }),
          ),
      ),
    ),
  );

  updateMachineServiceTask$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TMachineServiceInfoActionType.UpdateMachineServiceTask),
      switchMap((action: MachineServiceListActions.UpdateMachineServiceTask) =>
        from(this.APIHelper.presentLoading()).pipe(
          take(1),
          map((loaderEl) => {
            return [loaderEl, action] as const;
          }),
        ),
      ),
      switchMap(([loaderEl, action]) =>
        this.mmDataService.updateMachineServiceTasks(action.payload).pipe(
          finalize(() => {
            this.APIHelper.dismissLoadingV2(loaderEl);
          }),
          map(() => {
            this.machineServiceListFacade.resetMachineServiceListInfo('ACTION');
            return new MachineServiceListActions.UpdateMachineServiceTaskSuccess();
          }),
          catchError(() => {
            return of(new MachineServiceListActions.UpdateMachineServiceTaskFailure());
          }),
        ),
      ),
    ),
  );
}
